import toPath from 'lodash/toPath';
import isFunction from 'lodash/isFunction';
import isError from 'lodash/isError';
import isWeakMap from 'lodash/isWeakMap';
import clone from 'lodash/clone';
import mutableSet from 'lodash/set';
import mutableMergeWith from 'lodash/mergeWith';

export const mergeWith = (source1, source2, customizer) => {
  const cloned = mutableMergeWith({}, source1);
  return mutableMergeWith(cloned, source2, customizer);
};

const cloneByPath = (object, path) => {
  const arrayPath = toPath(path);
  const { length } = arrayPath;
  const lastIndex = length - 1;
  let index = -1;
  const result = clone(Object(object));
  let nested = result;

  while (nested != null && ++index < length) {
    const key = arrayPath[index];
    const value = nested[key];

    if (
      value != null &&
      !(isFunction(value) || isError(value) || isWeakMap(value))
    ) {
      nested[key] = clone(index === lastIndex ? value : Object(value));
    }
    nested = nested[key];
  }
  return result;
};

export const set = (path, value, object) => {
  const cloned = cloneByPath(object, path);
  mutableSet(cloned, path, value);
  return cloned;
};
